





























































































































































import EmployeeAttendEdit from "@/components/EmployeeAttendEdit.vue";
import EmployeeAttendView from "@/components/EmployeeAttendView.vue";
import EmployeeStandByEdit from "@/components/EmployeeStandByEdit.vue";
import { AppConstants, Interfaces, Models, Utils, apiService } from "@/core/Export";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {
    EmployeeAttendView,
    EmployeeAttendEdit,
    EmployeeStandByEdit
  },
})
export default class EmployeeAttendDetails extends Vue {
  currentViewMode: string;
  isInSaveProcess: boolean;
  permissions: any;
  employeeAttendEditKey: number;
  employeeStandByEditKey: number;
  employeePortalMinDto: any;
  selectedEmployeeNomination: Models.TBaseItem | null;
  /** Prevents resetting chosen nomination when getEmployeePortalMin runs for the same employee. */
  nominationLogicEmployeeKey: number | null;

  constructor() {
    super();
    this.currentViewMode = null;
    this.isInSaveProcess = false;
    this.permissions = AppConstants.Permissions;
    this.employeeAttendEditKey = 0;
    this.employeeStandByEditKey = 0;
    this.employeePortalMinDto = {
      nominations: [],
      useNominations: false,
      isStandBy: false
    };
    this.selectedEmployeeNomination = null;
    this.nominationLogicEmployeeKey = null;

  }

  public async created() {
    await this.onGetEmployeePortalMin();
    await this.onSetViewMode("view");
  }

  @Watch("selectedYear")
  @Watch("selectedMonth")
  @Watch("currentEmployee")
  public async onParamsChanged(): Promise<void> {
    await this.onGetEmployeePortalMin();
    await this.onSetViewMode(this.currentViewMode, true);
  }

  public async onSetViewMode(mode: string, isParamsChanged: boolean = false, forceCalc: boolean = false): Promise<void> {
    if (!isParamsChanged && mode == this.currentViewMode) return;
    this.currentViewMode = mode;
    if (!this.employeePortalMinDto.isStandBy && this.currentViewMode == "editStandby") this.currentViewMode = "view";

    switch (this.currentViewMode) {
      case "view":
        await this.onGetEmployeeAttendViewData(forceCalc);
        break;
      case "edit":
        await this.onGetEmployeeAttendEditData();
        break;
      case "editStandby":
        await this.onGetEmployeeStandByEditData();
        break;
      default:
        break;
    }
  }

  public onSelectEmployeeNominationChanged(nomination: Models.TBaseItem): void {
    this.onSetSelectedEmpNomination(nomination);
    this.onSetViewMode(this.currentViewMode, true);
  }

  public runEmpNominationsLogic(): void {
    if (!this.employeePortalMinDto.useNominations || this.employeePortalMinDto.nominations.length == 0) {
      this.onSetSelectedEmpNomination(null);
      this.nominationLogicEmployeeKey = null;
      return;
    }

    const nominations = this.employeePortalMinDto.nominations;
    const empId =
      this.currentEmployee && (this.currentEmployee as any).id != null
        ? (this.currentEmployee as any).id
        : null;
    const previousId = store.getters.selectedEmpNominationId as number;
    const sameEmployeeContext =
      empId != null && this.nominationLogicEmployeeKey === empId;

    if (sameEmployeeContext && previousId > 0) {
      const keepNomination = nominations.find(q => q.id === previousId);
      if (keepNomination) {
        this.selectedEmployeeNomination = keepNomination;
        store.commit(AppConstants.StoreMutations.UpdateSelectedEmpNominationId, keepNomination.id);
        return;
      }
    }

    this.nominationLogicEmployeeKey = empId;

    if (this.currentEmployee) {
      if (this.currentEmployee.empNominationId > 0) {
        let nomination = nominations.find(q => q.id == this.currentEmployee.empNominationId);
        if (!nomination) nomination = nominations[0];
        this.onSetSelectedEmpNomination(nomination);
        return;
      }
    }

    this.onSetSelectedEmpNomination(nominations[0]);
  }

  public onSetSelectedEmpNomination(nomination: Models.TBaseItem | null): void {
    this.selectedEmployeeNomination = nomination;
    let id: number = 0;
    if (this.selectedEmployeeNomination != null) id = this.selectedEmployeeNomination.id;
    store.commit(AppConstants.StoreMutations.UpdateSelectedEmpNominationId, id);
  }

  public async onGetEmployeePortalMin(): Promise<void> {
    let dto = await store.dispatch(AppConstants.StoreActions.GetEmployeePortalMin);
    if (dto == null) return;
    this.employeePortalMinDto = dto;
    this.runEmpNominationsLogic();
  }

  public async onGetEmployeeAttendViewData(forceCalc: boolean = true): Promise<void> {
    await store.dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData, { forceCalc: forceCalc });
  }

  public async onGetEmployeeAttendEditData(): Promise<void> {
    await store.dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendEditData);
  }

  public async onGetEmployeeStandByEditData(): Promise<void> {
    await store.dispatch(AppConstants.StoreActions.GetEmployeeStandByEditData);
  }

  onSaveAttendEdit() {
    let hasErrors = this.onCheckSaveRules();
    this.employeeAttendEditKey = this.employeeAttendEditKey + 1;
    if (hasErrors) return;

    this.isInSaveProcess = true;
    this.appEnv.isBusy = true;
    apiService
      .saveNewEmployeeAttendMonthEntry(
        this.currentEmployee.id,
        this.selectedYear,
        this.selectedMonth,
        this.currentEmployee.salaryFactoryNo,
        this.employeeAttendEditData.days
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          Utils.Notification.notifyPositive(
            this.$t("msgs.save").toString(),
            "thumb_up"
          );
          this.onSetViewMode("view");
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.isInSaveProcess = false;
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.isInSaveProcess = false;
        this.appEnv.isBusy = false;
      });
  }

  onSaveStandByEdit() {
    let hasErrors = this.onCheckStandBySaveRules();
    this.employeeStandByEditKey = this.employeeStandByEditKey + 1;
    if (hasErrors) return;
    this.isInSaveProcess = true;
    this.appEnv.isBusy = true;
    apiService
      .saveMonthlyEmployeeStandby(this.employeeStandByEditData.data)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          Utils.Notification.notifyPositive(
            this.$t("msgs.save").toString(),
            "thumb_up"
          );
          this.onSetViewMode("view", false, true);
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .catch((err) => {
      }).finally(() => {
        this.isInSaveProcess = false;
        this.appEnv.isBusy = false;
      })
  }

  onCheckSaveRules(): boolean {
    let daysWithData = this.employeeAttendEditData.days.filter(
      (s) =>
        s.hasNotesError ||
        s.hasEntryNotSingingReasonError ||
        s.hasExitNotSingingReasonError ||
        s.entryLog.timeText ||
        s.exitLog.timeText ||
        s.pairs.length > 0 ||
        s.hasSpecialEventRequiredError
    );
    let attendWithOutRemark = this.appEnv.isAllowed(
      AppConstants.Permissions.AttendWithoutRemark
    );
    let isNotSingingReasonRequired = this.appEnv.isAllowed(
      AppConstants.Permissions.PortalNotSignReasonMandatory
    );
    let notSignReasons =
      store.getters.baseItems[AppConstants.BaseItems.NotSingingReason];
    let pairsWithErrors = [];

    daysWithData.forEach((day) => {
      this.appEnv.onSetAttendEditNotesFieldError(
        day,
        attendWithOutRemark,
        notSignReasons
      );
      this.appEnv.onSetEntryNotSingingReasonErrorFieldError(
        day,
        isNotSingingReasonRequired
      );
      this.appEnv.onSetAttendSpecialEventFieldError(day);

      let pairsWithData = day.pairs.filter(
        (s) =>
          s.hasNotesError ||
          s.hasEntryNotSingingReasonError ||
          s.hasExitNotSingingReasonError ||
          s.entryLog.timeText ||
          s.exitLog.timeText ||
          s.hasSpecialEventRequiredError
      );
      pairsWithData.forEach((pair) => {
        this.appEnv.onSetAttendEditNotesFieldError(
          pair,
          attendWithOutRemark,
          notSignReasons
        );
        this.appEnv.onSetEntryNotSingingReasonErrorFieldError(
          pair,
          isNotSingingReasonRequired
        );
        this.appEnv.onSetAttendSpecialEventFieldError(pair);
        if (
          pair.hasNotesError ||
          pair.hasEntryNotSingingReasonError ||
          pair.hasExitNotSingingReasonError ||
          pair.hasSpecialEventRequiredError && (
            pair.missingEventId == 0)
        )
          pairsWithErrors.push(pair);
      });
    });

    let daysWithErrors = daysWithData.filter(
      (s) =>
        s.hasNotesError ||
        s.hasEntryNotSingingReasonError ||
        s.hasExitNotSingingReasonError ||
        s.hasSpecialEventRequiredError && (
          s.missingEventId == 0)
    );
    if (
      (daysWithErrors && daysWithErrors.length > 0) ||
      pairsWithErrors.length > 0
    ) {
      let datesWithError = [];
      daysWithErrors.map((date) => {
        datesWithError.push(Utils.Date.formatDate(date.actualDate));
      });
      let errorMsg =
        this.$t("msgs.errors_in_dates") + ": " + datesWithError.join(", ");
      this.appEnv.showErrorDialog([{ message: errorMsg }]);
      return true;
    }
    return false;
  }

  onCheckStandBySaveRules(): boolean {
    let standByDaysWithData = this.employeeStandByEditData.data.filter(
      (day) => day.startTimeText || day.endTimeText
    );
    let standByDaysWithErrors = [];
    standByDaysWithData.forEach((day) => {
      day.hasStartTimeError = false;
      day.hasEndTimeError = false;

      if (!day.startTimeText) {
        day.hasStartTimeError = true;
      }

      if (!day.endTimeText) {
        day.hasEndTimeError = true;
      }

      if (day.hasStartTimeError || day.hasEndTimeError) {
        standByDaysWithErrors.push(day);
      }
    });
    if (standByDaysWithErrors.length > 0) {
      let standByDatessWithError = standByDaysWithErrors.map((day) =>
        Utils.Date.formatDate(day.date)
      );
      let errorMsg =
        this.$t("msgs.errors_in_dates") + ": " + standByDatessWithError.join(", ");
      this.appEnv.showErrorDialog([{ message: errorMsg }]);
      return true;
    }
    return false;
  }

  onCancelAttendEdit() {
    this.onSetViewMode("view");
  }

  onCancelStandByEdit() {
    this.onSetViewMode("view");
  }

  onReportMissingEvent() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.ReportMissingEvent
    );
  }

  onCancelEmpApproval() {
    this.$q.dialog({
      title: this.$t("verification") as string,
      message: this.$t('msgs.cancel_employee_approval') as string,
      ok: this.$t("approve"),
      cancel: this.$t("reject"),
    }).onOk(async () => {
      try {
        this.appEnv.isBusy = true;
        let result: Interfaces.iServiceRequest = await apiService.saveAttendReportApproval({ amrId: this.employeeAttendViewData.amrId }, true, true);
        let call: Interfaces.iServiceCall = result.calls[0];
        if (!call) return;
        if (call.isSuccess) {
          await this.onGetEmployeeAttendViewData();
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      } catch (error) {
      }
      finally {
        this.appEnv.isBusy = false;
      }
    }).onCancel(() => {
    })
  }

  onPrintReport() {
    let reportModel = {
      employeeIds: [this.currentEmployee.id],
      orgStructId: null,
      year: this.selectedYear,
      month: this.selectedMonth,
      salaryFactoryNo: this.currentEmployee.salaryFactoryNo,
      fromDate: null,
      toDate: null,
      reportTypeCode: AppConstants.ReportCodes.Attend_Detail,
      openInNewTab: false,
    };
    // if the environment is kiosk push to another page to show the report
    this.appEnv.getReport(reportModel, "pdf").then((url) => {
      if (!url) return;
      if (!AppConstants.IsKioskMode) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: AppConstants.Routes.R_AttendReport,
          params: {
            reportUrl: url,
          },
        });
      }
    });
  }

  onOpenEmployeeSums() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.EmployeeSummary
    );
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
  }

  onOpenApprovalInfo(isManager: boolean = false, isAdditionalApproval: boolean = false, isSecretaryApproval: boolean = false) {
    if (this.hasAttendErrorsForSign(isManager) && !this.appEnv.isAllowed(AppConstants.Permissions.PortalSignMngrAllowErrorsRecords)) {
      this.appEnv.showErrorDialog([
        { message: this.$t("msgs.cannot_sign_report") },
      ]);
      return;
    }

    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.ApprovalInfo
    );
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
      isManager: isManager,
      approval: this.approval,
      amrId: this.employeeAttendViewData.amrId,
      isAdditionalApproval: isAdditionalApproval,
      isSecretaryApproval: isSecretaryApproval
    });
  }

  hasAttendErrorsForSign(isManager: boolean) {
    var attendErrors = Boolean(
      this.employeeAttendViewData.lines.find(
        (s) => s.err_Retzef || s.err_MissingEntry
      )
    );
    if (isManager) {
      return !this.approval.empManagerApprovalDate && attendErrors;
    }
    return !this.approval.empApprovalDate && attendErrors;
  }

  isMangerEmpApproveMonthVisible() {
    if (this.isEmployeeDetailsRoute) {
      var toApprove = Boolean(
        this.employeeAttendViewData.lines.find(
          (s) =>
            s.entryStateCode == AppConstants.EntryExitLogStates.To_Approve ||
            s.exitStateCode == AppConstants.EntryExitLogStates.To_Approve
        )
      );
      return toApprove;
    }
    return false;
  }

  isSecretaryEmpApprovalIconVisible() {
    if (this.isEmployeeDetailsRoute) {
      if (this.approval.empSecretaryApprovalDate && this.approval.empApprovalDate)
        return true;
      return this.approval.isEmpSecretaryApproveEnabled;
    } else {
      return (
        this.approval.empSecretaryApprovalDate && this.approval.empApprovalDate
      );
    }
  }

  isAdditionalEmpApprovalIconVisible() {
    if (this.isEmployeeDetailsRoute) {
      if (this.approval.empAdditionalApprovalDate)
        return true;
      return this.approval.isEmpAdditionalApproveEnabled;
    } else {
      return (
        this.approval.empAdditionalApprovalDate && this.approval.empApprovalDate
      );
    }
  }

  isManagerEmpApprovalIconVisible() {
    if (this.isEmployeeDetailsRoute) {
      if (this.approval.empManagerApprovalDate)
        return true;
      return this.approval.isEmpManagerApproveEnabled;
    } else {
      return (
        this.approval.empManagerApprovalDate && this.approval.empApprovalDate
      );
    }
  }

  get isManagerCancelEmpApprovalVisible(): boolean {
    return this.isEmployeeDetailsRoute && this.approval.isEmpManagerCanCancelEmpApproval;
  }

  isEmpApprovalIconVisible() {
    if (!this.isAllowViewAttendAndSummaries) return false;
    // In manager screen, show employee signature status only when already signed.
    if (this.isEmployeeDetailsRoute) return Boolean(this.approval.empApprovalDate);
    if (this.approval.empApprovalDate) return true;
    if (this.approval.isEmpApproveEnabled) return true;
    return this.isEmpSignVisibleForMultiNominationFallback();
  }

  isEmpSignVisibleForMultiNominationFallback(): boolean {
    // Fallback is relevant only to employee portal flow.
    if (this.isEmployeeDetailsRoute) return false;
    if (!this.employeePortalMinDto.useNominations || this.employeePortalMinDto.nominations.length <= 1) {
      return false;
    }
    const view = this.employeeAttendViewData;
    if (!view || !view.amrId) return false;
    if (view.isPortalLocked) return false;
    if (this.approval.empApprovalDate) return false;
    // Employee monthly signature should not appear for current/future months.
    if (this.isCurrentOrFutureSelectedMonth()) return false;
    return true;
  }

  isCurrentOrFutureSelectedMonth(): boolean {
    const selectedMonthNumber = Number(this.selectedMonth);
    const selectedYearNumber = Number(this.selectedYear);
    if (!selectedMonthNumber || !selectedYearNumber) return false;

    const currentYear = Number(this.appEnv.UserInfo.currentYear);
    const currentMonth = Number(this.appEnv.UserInfo.currentMonth);
    if (!currentMonth || !currentYear) return false;
    if (selectedYearNumber > currentYear) return true;
    if (selectedYearNumber < currentYear) return false;
    return selectedMonthNumber >= currentMonth;
  }
  approvalAllPendingApproval() {
    if (this.appEnv.UserInfo.isManager && this.isEmployeeDetailsRoute) {
      store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
      store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
      store.commit(
        AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
        AppConstants.DrawerComponnents.EmployeeAttendMonthApprove
      );
    }
  }

  public get isEmployeeNominationButtonDisabled(): boolean {
    return this.currentViewMode == "edit";
  }

  get isAmrCheckStateCodeButtonVisible() {
    return this.currentViewMode == "view" && (this.employeeAttendViewData.amrCheckStateCode == AppConstants.AttendMonthCheckStateStatusCodes.checked || this.employeeAttendViewData.amrCheckStateCode == AppConstants.AttendMonthCheckStateStatusCodes.moved_to_salary);
  }

  get isEditAttendMonthVisible() {
    if (!this.canEditMonth) return true;

    if (this.isPortalLocked) return true;
    let empAttendReadyOnly = this.appEnv.isAllowed(AppConstants.Permissions.EmpAttendReadyOnly);
    let writeLog = this.appEnv.isAllowed(AppConstants.Permissions.WriteLog);
    if (empAttendReadyOnly) {
      return true;
    } else if (this.approval.empApprovalDate || this.approval.empManagerApprovalDate) {
      return true;
    } else {
      return !writeLog;
    }
  }

  get isReportMissingEventButtonVisible() {
    if (!this.canEditMonth) return true;

    if (this.isPortalLocked) return true;
    let empAttendReadyOnly = this.appEnv.isAllowed(AppConstants.Permissions.EmpAttendReadyOnly);
    let writeEvent = this.appEnv.isAllowed(AppConstants.Permissions.WriteEvent);
    if (empAttendReadyOnly) {
      return true;
    } else if (this.approval.empApprovalDate || this.approval.empManagerApprovalDate) {
      return true;
    } else {
      return !writeEvent;
    }
  }

  get canEditMonth() {
    return store.getters.canEditMonth;
  }

  get isPortalLocked() {
    return this.employeeAttendViewData.isPortalLocked;
  }

  get isEmployeeDetailsRoute() {
    return this.$route.name == AppConstants.Routes.M_Employee_Details;
  }

  get approval() {
    return this.employeeAttendViewData.approval;
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  get employeeAttendEditData() {
    return store.getters.employeeAttendEditData;
  }

  get employeeStandByEditData() {
    return store.getters.employeeStandByEditData;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  set currentEmployee(value) {
    store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, value);
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get isAllowViewAttendAndSummaries() {
    if (
      this.appEnv.isAllowed(
        AppConstants.Permissions.PortalLimitViewAtAttendanceAndSummaries
      )
    ) {
      return false;
    }
    return true;
  }

  get isAllowViewAtSummaries() {
    if (
      this.appEnv.isAllowed(
        AppConstants.Permissions.PortalLimitViewAtSummaries
      )
    ) {
      return false;
    }
    return true;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
